<template>
  <app-page title="Add Labels">
    <v-ons-list>
      <v-ons-list-header>Enter product and label</v-ons-list-header>
      <v-ons-list-item v-if="displayTypes.length > 1">
          <v-ons-segment :index="displayTypeIndex" @update:index="selectDisplayType" style="width: 100%">
            <button v-for="dt in displayTypes" :key="dt.id">{{dt.id}}</button>
          </v-ons-segment>
      </v-ons-list-item>
      <v-ons-list-item>
        <div class="center">
          <v-ons-input disable-auto-styling
            placeholder="Product"
            input-id="product" 
            v-model="product"
            @keydown.enter="enterProduct"
            @keydown.tab="enterProduct"
            :disabled="!enableProduct"/>
        </div>
        <div class="right">
          <v-ons-switch
            v-model="enableProduct" 
            :disabled="!product"/>
        </div>
      </v-ons-list-item>
      <v-ons-list-item>
        <v-ons-input disable-auto-styling
          placeholder="Label"
          input-id="label"
          v-model="label"
          @keydown.enter="enterLabel"
          @keydown.tab="enterLabel"
          :disabled="!product"/>
      </v-ons-list-item>
    </v-ons-list>
    <v-ons-list v-show="!!$store.addedLabels.length">
      <v-ons-list-header>Labels to be added</v-ons-list-header>
      <v-ons-list-item v-for="item in $store.addedLabels" :key="item.label">
        <div class="center label-item">
          {{item.label}}
          &rarr;&nbsp;
          <span :class="{ error: item.error }">{{item.product}}</span>
        </div>
        <div class="right">
          <v-ons-icon
            @click="removeItem(item.label)" 
            icon="fa-times-circle" 
            class="remove-icon"/>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  </app-page>
</template>

<script>
import util from "../util";
export default {
  data: () => ({
    product: "",
    label: "",
    displayTypeIndex: localStorage.getObject("displayTypeIndex") || 0,
    displayTypes: [],
    enableProduct: true
  }),
  async created() {
    const dtypes = await this.$api.getDisplayTypes();
    this.displayTypes = Object.values(dtypes);
  },
  mounted() {
    this.setFocus();
  },
  methods: {
    selectDisplayType(i) {
      this.displayTypeIndex = i;
      localStorage.setObject("displayTypeIndex", i);
      this.setFocus();
    },
    setFocus() {
      util.focus(this.enableProduct ? "product" : "label");  
    },
    removeItem(label) {
      this.$store.addedLabels = this.$store.addedLabels.filter(
        item => item.label !== label);
      this.setFocus();
    },
    enterLabel(evt) {
      evt.preventDefault();
      if (this.labelIsValid) {
        this.$store.addedLabels = 
          this.$store.addedLabels.filter(
            item => item.label !== this.label);
        this.$store.addedLabels.splice(0, 0, {
          label: this.label,
          product: this.product,
          displayType: this.displayTypes[this.displayTypeIndex].id,
          error: false
        });
        if (this.enableProduct) {
          this.product = "";
          document.getElementById("product").focus();
        }
        util.sounds.success.play();
      } else {
        util.warn(this, "Invalid label: " + this.label, null);
      }
      this.label = "";
    },
    enterProduct(evt) {
      evt.preventDefault();
      if (this.product.length > 0) {
        document.getElementById("label").focus();
      }
    }
  },
  computed: {
    labelIsValid() { 
      return util.validateLabel(this.label); 
    }
  }
};
</script>

<style scoped>
.error {
  color: red;
  text-decoration-line: underline;
  text-decoration-style: wavy;
}
.label-item {
  font-family: monospace;
}
.remove-icon {
  color: red;
}
.remove-icon:hover {
  color: blue;
  cursor: pointer;
}
.list--material {
  border-bottom: solid 1px lightgray;
}
.list-header--material {
  background: #efeff4;
  text-transform: uppercase;
  line-height: normal;
  border-bottom: solid 1px lightgray;
}
</style>



// WEBPACK FOOTER //
// src/pages/AddPage.vue